import { render, staticRenderFns } from "./ScreeningRecommendation.vue?vue&type=template&id=0fc21e48&scoped=true&"
import script from "./ScreeningRecommendation.vue?vue&type=script&lang=js&"
export * from "./ScreeningRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningRecommendation.vue?vue&type=style&index=0&id=0fc21e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc21e48",
  null
  
)

export default component.exports